import { useContext, createContext } from "react";
import { useLocalObservable } from "mobx-react";
import stores from "src/stores";
import { IAuthenticationStore } from "src/stores/authenticationStore.d";
import { IApplicationStore } from "src/stores/applicationStore.d";
import { IAdminStore } from "src/stores/adminStore.d";
import { IVehicleStore } from "src/stores/vehicleStore.d";

export interface IStoreContext {
  app: IApplicationStore;
  auth: IAuthenticationStore;
  admin: IAdminStore;
  vehicle: IVehicleStore;
}

const storeContext = createContext({} as IStoreContext);

export const useStore = (): IStoreContext => {
  return useContext(storeContext);
};

export const ProvideStore = ({ children }) => {
  const store = useLocalObservable(() => stores);
  return (
    <storeContext.Provider value={store}>{children}</storeContext.Provider>
  );
};
